import { Theme } from "@mui/material/styles";

const consentsFieldsStyles = {
  error: (theme: Theme) =>
    ({
      color: theme.palette.error.main + " !important",
      marginBottom: 0,
    }) as const,
};

export default consentsFieldsStyles;
